import { ENV_MODE } from '@/config';

const fixBootstrapError = (): void => {
  // eslint-disable-next-line
  const consoleError = console.error.bind(console);
  // eslint-disable-next-line
  console.error = (errObj, ...args) => {
    if (ENV_MODE?.toLowerCase() === 'local' && typeof errObj === 'string' && args.includes('findDOMNode')) {
      return;
    }
    consoleError(errObj, ...args);
  };
};

export { fixBootstrapError };
